import { defineComponent as i, ref as f, computed as $, openBlock as p, createElementBlock as M, normalizeClass as c, renderSlot as r, resolveComponent as d, createElementVNode as v, createVNode as O, withModifiers as w, toRef as C, createBlock as h, withCtx as u, mergeProps as x, createCommentVNode as g } from "vue";
import { usePopoverState as b } from "@onereach/ui-components-common/hooks";
import { O as B } from "./OrOverlay-BjrghiC-.mjs";
import { _ as y } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
import { O as F } from "./OrIconButton-BlHCLpeW.mjs";
import { useResponsive as H } from "@onereach/ui-components-common";
const z = [
  // Overflow
  "overflow-auto",
  // Spacing
  "px-md md:px-lg"
], I = i({
  name: "OrModalContent",
  expose: [
    "root"
  ],
  setup() {
    const o = f(), e = $(() => [
      "or-modal-content",
      ...z
    ]);
    return {
      root: o,
      rootStyles: e
    };
  }
});
function N(o, e, t, s, n, a) {
  return p(), M("div", {
    ref: "root",
    class: c(o.rootStyles)
  }, [
    r(o.$slots, "default")
  ], 2);
}
const V = /* @__PURE__ */ y(I, [["render", N]]), A = [
  // Spacing
  "px-md md:px-lg"
], E = i({
  name: "OrModalFooter",
  expose: [
    "root"
  ],
  setup() {
    const o = f(), e = $(() => [
      "or-modal-footer",
      ...A
    ]);
    return {
      root: o,
      rootStyles: e
    };
  }
});
function L(o, e, t, s, n, a) {
  return p(), M("div", {
    ref: "root",
    class: c(o.rootStyles)
  }, [
    r(o.$slots, "default")
  ], 2);
}
const P = /* @__PURE__ */ y(E, [["render", L]]), R = [
  // Layout
  "layout-row",
  // Spacing
  "px-md md:px-lg pb-sm md:pb-none",
  // Typography
  "typography-headline-2"
], j = i({
  name: "OrModalHeader",
  components: {
    OrIconButton: F
  },
  emits: [
    "close"
  ],
  expose: [
    "root"
  ],
  setup() {
    const o = f(), { isMobile: e } = H(), t = $(() => [
      "or-modal-header",
      ...R
    ]);
    return {
      root: o,
      rootStyles: t,
      isMobile: e
    };
  }
}), q = {
  class: /* @__PURE__ */ c(["grow"])
};
function D(o, e, t, s, n, a) {
  const l = d("OrIconButton");
  return p(), M("div", {
    ref: "root",
    class: c(o.rootStyles)
  }, [
    v("div", q, [
      r(o.$slots, "default")
    ]),
    O(l, {
      icon: "close",
      size: o.isMobile ? "l" : "xl",
      onClick: e[0] || (e[0] = w((_) => o.$emit("close"), ["stop"]))
    }, null, 8, ["size"])
  ], 2);
}
const G = /* @__PURE__ */ y(j, [["render", D]]);
var m = /* @__PURE__ */ ((o) => (o.L = "l", o.M = "m", o.S = "s", o))(m || {});
const J = [
  // Layout
  "layout-column",
  // Box
  "xs:w-full sm:w-full",
  "xs:h-full sm:h-full md:h-auto md:max-h-[min(calc(100%-(2*theme(spacing.3xl))),772px)]",
  // Spacing
  "py-md md:py-lg",
  "gap-md md:gap-lg",
  // Shape
  "md:rounded-md",
  // Elevation
  "shadow-modal",
  "dark:shadow-modal-dark",
  // Typography
  "typography-body-2-regular",
  // Theme
  "theme-background-default",
  "dark:theme-background-default-dark",
  "theme-foreground-default",
  "dark:theme-foreground-default-dark"
], K = {
  [m.L]: [
    // Box
    "md:w-[1050px]"
  ],
  [m.M]: [
    // Box
    "md:w-[700px]"
  ],
  [m.S]: [
    // Box
    "md:w-[480px]"
  ]
}, Q = i({
  name: "OrModal",
  components: {
    OrModalContent: V,
    OrModalFooter: P,
    OrModalHeader: G,
    OrOverlay: B
  },
  inheritAttrs: !1,
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: () => m.M
    },
    // TODO: Remove after migration to Vue 3
    additionalStyles: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    "update:state",
    "open",
    "close"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close"
  ],
  setup(o, e) {
    const t = f(), s = $(() => [
      "or-modal-v3",
      ...J,
      ...K[o.size],
      ...o.additionalStyles
    ]), { state: n, open: a, close: l } = b(C(o, "isOpen"), e.emit);
    return {
      root: t,
      rootStyles: s,
      state: n,
      open: a,
      close: l
    };
  }
});
function T(o, e, t, s, n, a) {
  const l = d("OrModalHeader"), _ = d("OrModalContent"), k = d("OrModalFooter"), S = d("OrOverlay");
  return o.state === "open" ? (p(), h(S, {
    key: 0,
    fullscreen: !0
  }, {
    default: u(() => [
      v("div", x(o.$attrs, {
        ref: "root",
        class: o.rootStyles
      }), [
        O(l, {
          onClose: e[0] || (e[0] = (U) => o.close())
        }, {
          default: u(() => [
            r(o.$slots, "header")
          ]),
          _: 3
        }),
        O(_, {
          class: c(["grow"])
        }, {
          default: u(() => [
            r(o.$slots, "default")
          ]),
          _: 3
        }),
        o.$slots.footer ? (p(), h(k, { key: 0 }, {
          default: u(() => [
            r(o.$slots, "footer")
          ]),
          _: 3
        })) : g("", !0)
      ], 16)
    ]),
    _: 3
  })) : g("", !0);
}
const to = /* @__PURE__ */ y(Q, [["render", T]]);
export {
  m as M,
  to as O
};
//# sourceMappingURL=OrModal-CQhwUYFk.mjs.map
